import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import TitleBlock from '../TitleBlock';
import HotelImage from '../../assets/images/brand/hotelimg.png';
import { Link } from 'react-router-dom';
const Branches = () => {
  const rot = ['fsda', 'sdf', 'as'];
  return (
    <div>
      <TitleBlock
        number='02'
        pretitle='outposts'
        title='visit our branches'
        desc='Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptate
          aliquid nesciunt pariatur reprehenderit, possimus labore eligendi
          beatae facilis eum maiores. Laudantium repellat veniam obcaecati sed
          dolores laborum unde placeat quod.'
      />
      <Container>
        <Row>
          {rot.map((m) => (
            <Col md={4}>
              <section className='branchCard'>
                <figure className='branchCard-image'>
                  <img src={HotelImage} alt='' />
                </figure>
                <h2 className='branchCard-title'>Butwal Branch</h2>

                <p className='branchCard-paragraph'>
                  Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                  Vitae quasi dolore magnam hic esse aperiam obcaecati aliquam
                  distinctio doloremque atque.
                </p>

                <section className='text-center'>
                  <Link to="/branch" className='bton bton--md bton--ghost'>
                   Discover More
                  </Link>
                </section>
              </section>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Branches;
